/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ConseillerPedagogiqueSearch
 */
export interface ConseillerPedagogiqueSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ConseillerPedagogiqueSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ConseillerPedagogiqueSearch
     */
    prenom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ConseillerPedagogiqueSearch
     */
    idconseillerPedagogique?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof ConseillerPedagogiqueSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConseillerPedagogiqueSearch
     */
    selectedIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConseillerPedagogiqueSearch
     */
    availableIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConseillerPedagogiqueSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ConseillerPedagogiqueSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ConseillerPedagogiqueSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConseillerPedagogiqueSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ConseillerPedagogiqueSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ConseillerPedagogiqueSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ConseillerPedagogiqueSearch interface.
 */
export function instanceOfConseillerPedagogiqueSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConseillerPedagogiqueSearchFromJSON(json: any): ConseillerPedagogiqueSearch {
    return ConseillerPedagogiqueSearchFromJSONTyped(json, false);
}

export function ConseillerPedagogiqueSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConseillerPedagogiqueSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : TextSearchFromJSON(json['prenom']),
        'idconseillerPedagogique': !exists(json, 'idconseillerPedagogique') ? undefined : TextSearchFromJSON(json['idconseillerPedagogique']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ConseillerPedagogiqueSearchToJSON(value?: ConseillerPedagogiqueSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'prenom': TextSearchToJSON(value.prenom),
        'idconseillerPedagogique': TextSearchToJSON(value.idconseillerPedagogique),
        'actif': BooleanSearchToJSON(value.actif),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

